// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2PJgP","choiceBoxes":"toolbarselects_choiceBoxes__2FvOl","simpleField":"toolbarselects_simpleField__3rB1Q"};